<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapCustomerMaterialMapping"
        @reset="resetHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
            <el-form-item label="工厂">
              <el-input v-model.trim="filter.salesOrgan" placeholder="请输入工厂" clearable/>
            </el-form-item>
            <el-form-item label="客户编号">
              <el-input v-model.trim="filter.customerNo" placeholder="请输入客户编号" clearable/>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
            </el-form-item>
            <el-form-item label="客户物料编号">
              <el-input v-model.trim="filter.customerMaterialNo" placeholder="请输入客户物料编号" clearable/>
            </el-form-item>
            <el-form-item label="客户物料描述">
              <el-input v-model.trim="filter.customerMaterialDesc" placeholder="请输入客户物料描述" clearable/>
            </el-form-item>
            <el-form-item label="客户物料规格型号">
              <el-input v-model.trim="filter.customerMaterialSpecification" placeholder="请输入客户物料规格型号" clearable/>
            </el-form-item>

            <el-form-item label="创建时间">
              <el-date-picker
                  v-model="createTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>
            </el-form-item>

            <!--            <el-form-item label="订单类型">-->
            <!--              <el-select-->
            <!--                  v-model="filter.salesOrderCategory"-->
            <!--                  clearable-->
            <!--                  placeholder="请选择订单类型">-->
            <!--                <el-option v-for="item in property" :key="item.no" :value="item.no" :label="item.name"/>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.subAuth"
            type="primary"
            :loading="submitLoading"
            :disabled="scope.row.status !== 10"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
        <el-button
            v-if="limits.creatDeliveryAuth"
            type="primary"
            :disabled="scope.row.status === 10"
            @click="$refs.sapDeliveryEdt.open(scope.row)">
          交货单
        </el-button>
      </template>
    </view-table>
    <sales-order-edit ref="salesOrderEdit" :options="options" @save-success="loadData"/>
    <sap-delivery-edit ref="sapDeliveryEdt"/>
  </div>
</template>

<script>
  import SalesOrderEdit from "@/views/SalesManage/SalesOrder/SalesOrderEdit";
  import ViewTable from "@/components/ViewTable";
  import SapDeliveryEdit from "@/views/SalesManage/DeliveryBll/SapDeliveryEdit";

  export default {
    name: "CustomerMaterialMappingList",
    components: {SapDeliveryEdit, SalesOrderEdit,ViewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(107),
          editAuth: this.$auth(108),
          delAuth: this.$auth(109),
          subAuth: this.$auth(745),
          creatDeliveryAuth: this.$auth(693),
        },
        createTimeRange:[],
        submitLoading: false,
        filter: {
          salesOrgan:"",
          customerNo:"",
          materialNo:"",
          customerMaterialNo:"",
          customerMaterialDesc:"",
          customerMaterialSpecification:"",
          createTimeBegin:"",
          createTimeEnd:"",
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "salesOrderNO",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.salesOrderEdit.open(params.row, 0, true);
                    },
                  },
                },
                params.row.salesOrderNO,
              );
            },
          },
          {
            key: "action",
            width: 250,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },


      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.salesOrderEdit.open(row);
      },

      //未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.demandStatus !== "Y") {
          return  false;
        } else {
          return  true;
        }
      },
    },
  };
</script>
